import React from 'react';

export type LevelTagProps = {
  children: React.ReactNode;
};

export const LevelTag: React.FC<LevelTagProps> = ({ children }) => (
  <span className="rounded bg-gray-100 px-1.5 py-0.5 font-medium text-gray-700">
    {children}
  </span>
);
